<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Selected1`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_a8d5295d5e__clip0_591_1527)"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 15C11.0899 15 14 12.0899 14 8.5C14 4.91015 11.0899 2 7.5 2C3.91015 2 1 4.91015 1 8.5C1 12.0899 3.91015 15 7.5 15ZM7.49995 13.4999C10.2338 13.4999 12.45 11.2837 12.45 8.5499C12.45 5.81609 10.2338 3.5999 7.49995 3.5999C4.76614 3.5999 2.54995 5.81609 2.54995 8.5499C2.54995 11.2837 4.76614 13.4999 7.49995 13.4999Z"/></g><path fill-rule="evenodd" clip-rule="evenodd" d="M10.5407 6.54023C10.2869 6.28639 9.87532 6.28639 9.62148 6.54023L6.5405 9.62122L5.37891 8.45962C5.12507 8.20578 4.71351 8.20578 4.45967 8.45962C4.20583 8.71346 4.20583 9.12502 4.45967 9.37886L6.00588 10.9251C6.00784 10.927 6.00981 10.929 6.01179 10.9309C6.03094 10.9569 6.05226 10.9817 6.07576 11.0052C6.3296 11.259 6.74115 11.259 6.99499 11.0052L10.5407 7.45947C10.7946 7.20563 10.7946 6.79408 10.5407 6.54023Z"/><defs><clipPath id="svg_a8d5295d5e__clip0_591_1527"><path d="M0 0H16V16H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconSelected1',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
